import React from 'react';
import { Box, ButtonGroup, Button, Paper } from '@mui/material';

interface AlphabetNavProps {
  activeLetter: string;
  availableLetters: Set<string>;
  onLetterClick: (letter: string) => void;
}

export const AlphabetNav: React.FC<AlphabetNavProps> = ({
  activeLetter,
  availableLetters,
  onLetterClick
}) => {
  const alphabet = ['All', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];

  return (
    <Paper 
      elevation={0} 
      variant="outlined"
      sx={{ 
        p: 2,
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
          height: 10
        },
        '&::-webkit-scrollbar-track': {
          bgcolor: 'background.default',
          borderRadius: 5
        },
        '&::-webkit-scrollbar-thumb': {
          bgcolor: 'primary.light',
          borderRadius: 5,
          '&:hover': {
            bgcolor: 'primary.main'
          }
        }
      }}
    >
      <Box 
        component="nav"
        sx={{ 
          display: 'flex',
          justifyContent: 'center',
          minWidth: 'min-content'
        }}
      >
        <ButtonGroup variant="outlined">
          {alphabet.map((letter) => {
            const isAvailable = letter === 'All' || availableLetters.has(letter);
            const isActive = activeLetter === letter;

            return (
              <Button
                key={letter}
                onClick={() => onLetterClick(letter)}
                disabled={!isAvailable}
                sx={{
                  minWidth: letter === 'All' ? 72 : 56,
                  height: 56,
                  px: letter === 'All' ? 2 : 1,
                  fontSize: '1.25rem',
                  fontWeight: 500,
                  ...(isActive && {
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    '&:hover': {
                      bgcolor: 'primary.dark'
                    }
                  }),
                  ...(!isAvailable && {
                    opacity: 0.4,
                    border: '1px solid',
                    borderColor: 'divider'
                  }),
                  ...(isAvailable && !isActive && {
                    '&:hover': {
                      bgcolor: 'primary.lighter',
                      borderColor: 'primary.main'
                    }
                  })
                }}
              >
                {letter}
              </Button>
            );
          })}
        </ButtonGroup>
      </Box>
    </Paper>
  );
};